import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
} from '@mui/material';
import { AppContext } from 'context/AppContextProvider';
import ModalComponent from '../../../components/ModalComponent';
import { useGetOpenDoorEventAsync } from '../../../services/Events/OpenDoorEventService/hooks/useMutation';
import {
  getOpenDoorEventStreamByEndpointAsync,
} from '../../../services/Events/OpenDoorEventService';

interface Props {
  open: boolean;
  deviceId?: number | null;
  onClose: () => void;
}

const OpenDoorEventsModal = ({ open, deviceId, onClose }: Props) => {
  const { showSnackbar } = useContext(AppContext);
  const [events, setEvents] = useState<any[]>([]);
  const { mutateAsync: getEvents, isLoading } = useGetOpenDoorEventAsync();
  useEffect(() => {
    getOpenDoorEventStreamByEndpointAsync(setEvents);
  }, []);

  return (
    <ModalComponent
      isOpen={open}
      onClose={onClose}
      title="Histórico de aberturas"
    >
      <Box sx={{ maxHeight: 500, overflowY: 'auto' }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        ) : events.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Nenhum evento encontrado.
          </Typography>
        ) : (
          <List dense>
            {events.map((e) => (
              <React.Fragment key={e.id}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={`${e.name || 'Sem nome'} • ${e.deviceName ?? ''}`}
                    secondary={
                      <>
                        <Typography variant="caption" display="block">
                          CPF: {e.cpf || '-'}
                        </Typography>
                        <Typography variant="caption" display="block">
                          {e.description || 'Sem descrição'}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.7 }}>
                          {new Date(e.createdAt).toLocaleString()}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        )}
      </Box>
    </ModalComponent>
  );
};

export default OpenDoorEventsModal;
